<div class="bgimg">
	<div class="limiter bgimg_wrap"></div>
	<div class="limiter" style="position: absolute;z-index:1;">
		<div class="container-login100" style="background:none;">
			<div class="wrap-login100">
				<form class="login100-form validate-form">
					<span class="login100-form-title p-b-26">
						Welcome
					</span>
					<span class="login100-form-title p-b-48">
						<i class="zmdi zmdi-font"></i>
					</span>

					<div class="wrap-input100 validate-input" >
						<input class="input100 {{acc.length>0?'has-val':''}}" type="text"  [(ngModel)]="acc"  name="email">
						<span class="focus-input100"  data-placeholder="帳號"></span>
					</div>

					<div class="wrap-input100 validate-input" data-validate="Enter password">
						<span class="btn-show-pass">
							<i class="zmdi zmdi-eye"></i>
						</span>
						<input class="input100 {{acc.length>0?'has-val':''}}" type="password" name="pass"  [(ngModel)]="pwd"  (keyup.enter)="go()" >
						<span class="focus-input100" data-placeholder="密碼"></span>
					</div>

					<div class="container-login100-form-btn">
						<div class="wrap-login100-form-btn">
							<div class="login100-form-bgbtn"></div>
							<button class="login100-form-btn" style="background:#369" (click)=go()>
								Login
							</button>
						</div>
					</div>
					<div class="container-login100-form-btn" *ngIf="show_ams">
						<div class="wrap-login100-form-btn">
							<div class="login100-form-bgbtn"></div>
							<button class="login100-form-btn"  (click)=ams_login(-1)  style="background:rgb(80, 133, 11)" >使用Ams登入</button>

						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<app-toast></app-toast>